
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { Form } from './form';

export const ClienteFormPage = () => {
  const { id } = useParams();

  return (
    <ClienteFormState>
        <br />
        <Form title="Registrarse" />
    </ClienteFormState>
  );
};
